import React from 'react';

import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';

import { useCreateMembershipAllowedTime } from 'src/features/allowedTimes/api/membership/useCreateMembershipAllowedTime';
import AllowedTimeFormModal from 'src/features/allowedTimes/components/forms/AllowedTimeFormModal';
import { allowedTimesMessages } from 'src/features/allowedTimes/utils/messages';
import { useParking } from 'src/providers/ParkingProvider';
import { DataTableNewEntryProps } from 'src/registry/components/table/types';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';

interface CreateAllowedTimeFormModalProps<TData> extends DataTableNewEntryProps<TData> {
    children?: React.ReactNode;
}

function CreateMembershipAllowedTimeFormModal<TData>({ className, children }: CreateAllowedTimeFormModalProps<TData>) {
    const { formatMessage } = useIntl();
    const { membershipId = '' } = useParams();
    const { parkingId } = useParking();

    const { mutate, isPending } = useCreateMembershipAllowedTime({});

    return (
        <AllowedTimeFormModal
            className={className}
            mutate={(values, onSuccess, onError) => {
                values.map((data, index) =>
                    mutate(
                        { membershipId, parkingId, ...data },
                        index === values.length - 1 ? { onSuccess, onError } : {},
                    ),
                );
            }}
            title={formatMessage(generalMessages.createEntry, {
                entry: formatMessage(allowedTimesMessages.allowedTime).toLowerCase(),
            })}
            icon={ICON_MAP.ADD}
            isPending={isPending}
            subtitle={formatMessage(allowedTimesMessages.addAllowedTimeModalSubtitle)}
            children={children}
        />
    );
}

export default CreateMembershipAllowedTimeFormModal;
